<div class="row">

  <div class="col-sm-12">
    <div class="ticket">
      <div class="row">

        <div class="col-sm-12 col-md-8">
          <div class="title">{{ticket.title}}
            <small>at state {{ticket.state}}</small>
          </div>

          @if (assetTicket) {
            <div class="asset-title">
              {{assetTicket.asset.title}}
              <span> sensor at </span>{{ticket.site.title}}
            </div>
          }
          <div class="description">
            <pre>{{ticket.description}}</pre>
          </div>

          <div class="created-by text-right">
            Created {{ticket.createdAt | amTimeAgo}}
          </div>

        </div>

        <div class="col-sm-12 col-md-4 messages">
          @for (item of ticket.messages; track item) {
            <app-message-item [message]="item"></app-message-item>
          }

        </div>
      </div>

    </div>

  </div>

</div>
